import { Link } from "react-router-dom";
import { ArrowUpRight, ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { COMPANY } from "@/data/content";

export default function CTABand() {
  return (
    <section className="noise relative overflow-hidden bg-gradient-to-b from-midnight to-navy-light" data-testid="cta-band">
      <div className="pointer-events-none absolute -left-32 top-0 h-96 w-96 rounded-full bg-iris/20 blur-[140px]" />
      <div className="pointer-events-none absolute -right-24 bottom-0 h-80 w-80 rounded-full bg-aqua/15 blur-[120px]" />
      <div className="relative mx-auto w-full max-w-7xl px-6 py-24 lg:px-8 lg:py-32">
        <Reveal>
          <p className="text-xs font-bold uppercase tracking-[0.28em] text-aqua">Talk to Us</p>
        </Reveal>
        <Reveal delay={0.08}>
          <h2 className="mt-6 max-w-3xl font-display text-4xl font-extrabold leading-[1.05] tracking-tight text-white sm:text-5xl lg:text-6xl">
            Secure Your <span className="text-gradient">Digital Future</span>
          </h2>
        </Reveal>
        <Reveal delay={0.16}>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-slate-300">{COMPANY.tagline}</p>
        </Reveal>
        <Reveal delay={0.24}>
          <div className="mt-10 flex flex-wrap items-center gap-4">
            <Link
              to="/contact-us"
              data-testid="cta-band-primary-button"
              className="group inline-flex items-center gap-2 rounded-full bg-iris px-8 py-4 font-display text-sm font-bold text-white transition-all duration-300 hover:-translate-y-0.5 hover:bg-aqua hover:text-midnight"
            >
              Contact Us
              <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </Link>
            <Link
              to="/service"
              data-testid="cta-band-secondary-button"
              className="group inline-flex items-center gap-2 rounded-full border border-aqua/40 px-8 py-4 font-display text-sm font-bold text-aqua transition-all duration-300 hover:border-aqua hover:bg-aqua/10"
            >
              Explore Our Services
              <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
